/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

module.exports = {
    batchedUpdatePlugin: require('./batchedUpdatePlugin'),
    connectToStores: require('./connectToStores'),
    createElementWithContext: require('./createElementWithContext'),
    FluxibleComponent: require('./FluxibleComponent'),
    FluxibleMixin: require('./FluxibleMixin'),
    provideContext: require('./provideContext')
};



//////////////////
// WEBPACK FOOTER
// ./~/fluxible-addons-react/index.js
// module id = 15
// module chunks = 86